import { Box, Typography, alpha, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LuLayoutDashboard, LuHistory, LuUsers, LuBuilding, LuFileJson, LuClipboardCheck, LuMessageSquare } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../authentication/AuthProvider";
import SaveButton from "../../components/button/SaveButton";
import ThirdTabs from "../../components/tabs/ThirdTabs";
import { User } from "../../db_access/user";
import routing from "../../routing";
import PrebuiltTemplateManagement from "../Prebuilt_Template/PrebuiltTemplateManagement";
import ValidationDashboard from "../Validation/ValidationDashboard";
import LoginHistory from "./LoginHistory";
import ManageCompanies from "./ManageCompanies";
import ManageUsers from "./ManageUsers";
import SupportManagement from "./SupportManagement";

function AdminDashboard({ initialTab, noPadding, hideTabs }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const { isAdmin } = useAuth();
  const [isAuthorized, setIsAuthorized] = useState(true);

  const login_history = { label: "Login History", value: "Login History", tabIcon: LuHistory };
  const organization_management = { label: "Organizations", value: "Organizations", tabIcon: LuBuilding };
  const user_management = { label: "User Management", value: "User Management", tabIcon: LuUsers };
  const template_management = { label: "Template Management", value: "Template Management", tabIcon: LuFileJson };
  const validation_management = { label: "Validation Management", value: "Validation Management", tabIcon: LuClipboardCheck };
  const support_management = { label: "Support Management", value: "Support Management", tabIcon: LuMessageSquare };

  const [selectedTab, setSelectedTab] = useState(initialTab || organization_management.value);
  const options = [organization_management, user_management, template_management, validation_management, login_history, support_management];

  useEffect(() => {
    if (initialTab) {
      setSelectedTab(initialTab);
    }
  }, [initialTab]);

  useEffect(() => {
    if (!isAdmin) {
      navigate(routing.home);
    }
  }, [isAdmin, navigate]);

  useEffect(() => {
    User.get_user_type()
      .then((res) => res.ok ? res.json() : null)
      .then((data) => {
        if (data && data["user_type"] === "admin") {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
          navigate(routing.home);
        }
      });
  }, [navigate]);

  return (
    <Box sx={{ p: noPadding ? 0 : 3, bgcolor: 'transparent', minHeight: '100vh' }}>

      {!hideTabs && <ThirdTabs selection={selectedTab} setSelection={setSelectedTab} options={options} />}

      {isAuthorized && (
        <Box sx={{ transition: 'all 0.3s ease', mt: hideTabs ? 0 : 4 }}>
          {selectedTab === login_history.value && <LoginHistory />}
          {selectedTab === organization_management.value && <ManageCompanies />}
          {selectedTab === user_management.value && <ManageUsers />}
          {selectedTab === template_management.value && <PrebuiltTemplateManagement />}
          {selectedTab === validation_management.value && <ValidationDashboard />}
          {selectedTab === support_management.value && <SupportManagement />}
        </Box>
      )}
      <SaveButton />
    </Box>
  );
}

export default AdminDashboard;
